import { render, staticRenderFns } from "./CouponDiscountSegmentToggle.vue?vue&type=template&id=23b08277&scoped=true"
import script from "./CouponDiscountSegmentToggle.vue?vue&type=script&lang=js"
export * from "./CouponDiscountSegmentToggle.vue?vue&type=script&lang=js"
import style0 from "./CouponDiscountSegmentToggle.vue?vue&type=style&index=0&id=23b08277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b08277",
  null
  
)

export default component.exports